import { ListTypeTokens, ColorTokens, } from '@voltmoney/schema';
export const listTypeTokenMap = {
    [ListTypeTokens.CHECKLIST]: {
        labelColor: ColorTokens.White,
        bgColor: ColorTokens.Black,
    },
    [ListTypeTokens.DEFUALTLIST]: {
        labelColor: ColorTokens.White,
        bgColor: ColorTokens.Black,
    },
};
